/* global document */
import React, { useCallback, useContext, useEffect, useState } from 'react';
import '../styles/ExpandedProductImages.css';
import { useSearchParams } from 'react-router-dom';
import { LoadingContext } from './context/LoadingContext';
import { ToastContext } from './context/ToastContext';
import { Spinner } from 'react-bootstrap';

const ExpandedProductImages = () => {
    const [searchParams] = useSearchParams();
    const productId = searchParams.get('product_id');
    const { startLoading, finishLoading } = useContext(LoadingContext);
    const { sendMessage } = useContext(ToastContext);
    const [loading, setLoading] = useState(true);
    const [product, setProduct] = useState([]);
    const [productImages, setProductImages] = useState([]);
    const [currentImageIndex, setCurrentImageIndex] = useState(0);

    const fetchProductDetail = useCallback(async () => {
        try {
            startLoading();
            setLoading(true);
            const response = await fetch(new URL(`/api/products/${productId}`, process.env.APP_URL));
            const data = await response.json();
            if (data.error || !data.product) {
                sendMessage(data.error || 'Product not found.', 'danger');
                return;
            }
            setProduct(data.product);
            setProductImages(data.product.Images || []);
        } catch (error) {
            sendMessage(error.message, 'danger');
        } finally {
            finishLoading();
            setLoading(false);
        }
    }, [productId]);

    useEffect(() => {
        if (!productId) {
            sendMessage('Product ID is required to display images.', 'danger');
            return;
        }
        fetchProductDetail();
    }, [productId]);

    useEffect(() => {
        // Hide scrollbar when mounted
        document.body.style.overflow = 'hidden';

        return () => {
            // Re-enable scrollbar when unmounted
            document.body.style.overflow = '';
        };
    }, []);

    const handleSelectedIndexChange = useCallback((index) => () => setCurrentImageIndex(index), []);
    return (
        <div
            className={'expanded-product-images--container d-flex flex-column gap-2 justify-content-start align-items-center'}>
            {loading && <div
                className={'loading-spinner--container'}>
                <Spinner />
            </div>}
            {!loading && !productImages.length && <p
                className={'mt-5'}>No images available for this product.</p>}
            {!loading && productImages.length > 0 && (
                <div
                    className={'expanded-product-images--gallery'}>
                    <h2
                        className={'text-center'}>{product.title}</h2>
                    <img
                        src={productImages[currentImageIndex].url}
                        alt={product.title}
                        className={'expanded-product-images--main-image'}
                    />
                    <div
                        className={'expanded-product-images--thumbnails'}>
                        {productImages.map((image, index) => (
                            <button
                                key={image.id}
                                className={'unstyled-btn'}
                                onClick={handleSelectedIndexChange(index)}
                            >
                                <img
                                    src={image.url}
                                    alt={`Thumbnail ${index + 1}`}
                                    className={`expanded-product-images--thumbnail ${currentImageIndex === index ? 'active' : ''}`}
                                />
                            </button>
                        ))}

                    </div>
                    <p
                        className={'text-center text-muted mt-1'}>
                        Image {currentImageIndex + 1} of {productImages.length}
                    </p>
                </div>
            )}
        </div>
    );
};

export default ExpandedProductImages;